import {Component, Input, OnInit} from "@angular/core";
import {Batch, Channel, ChannelDefinition} from "../../../model/channels.model";
import {DecisionsService} from "../decisions.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {UtilsService} from "../../../services/utils.service";
import {DecisionsModel} from "../../../model/decisions.model";
import {MachineManagerService} from "../../../services/machine-manager.service";
import {Level, Message} from "../../../model/message.component";

@Component({
  selector: "admin-decisions-model",
  templateUrl: "./model.component.html",
  styleUrls: ["./model.component.css"]
})
export class ModelComponent implements OnInit {

  @Input() channel: ChannelDefinition = new ChannelDefinition();

  model?: DecisionsModel

  active = 1;

  constructor(
    private service: DecisionsService,
    private machineManager: MachineManagerService,
    private viewManager: ViewManagerService,
  ) {
  }

  ngOnInit(): void {
    this.service.model(this.channel.config!)
      .pipe()
      .subscribe({
        next: (result) => {
          this.model = result;
        },
        error: error => {
          console.log(error);
        }
      });
  }

  getCreatedAsDate() {
    return UtilsService.getAsDate(this.model?.created)
  }

  getUpdatedAsDate() {
    return UtilsService.getAsDate(this.model?.updated)
  }

  feedback(channel: Channel) {
    let batch = new Batch();
    batch.id = this.machineManager?.machine?.batch ?? "";
    batch.channel = channel;

    this.service.feedback(batch)
      .pipe()
      .subscribe({
        next: (result) => {
          this.viewManager.displayMessage(new Message("learning process is initiated for batch: " + batch.id, new Level("info")), 30000);
          this.viewManager.navigate(["admin/decisions"]);
        },
        error: error => {
          console.log(error);
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

  learn(channel: Channel) {
    let batch = new Batch();
    batch.id = this.machineManager?.machine?.batch ?? "";
    batch.channel = channel;

    this.service.learn(batch)
      .pipe()
      .subscribe({
        next: (result) => {
          this.viewManager.displayMessage(new Message("learning process is initiated for batch: " + batch.id, new Level("info")), 30000);
          this.viewManager.navigate(["admin/decisions"]);
        },
        error: error => {
          console.log(error);
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

  predict(channel: Channel) {
    let batch = new Batch();
    batch.id = this.machineManager?.machine?.batch ?? "";
    batch.channel = channel;

    this.service.review(batch)
      .pipe()
      .subscribe({
        next: (result) => {
          this.viewManager.displayMessage(new Message("review process is initiated for batch: " + batch.id, new Level("info")), 30000);
          this.viewManager.navigate(["admin/decisions"]);
        },
        error: error => {
          console.log(error);
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }
}
